/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-10-08 11:59:59
 */

/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-06-06 12:06:31
 */
import React, { useEffect, useState } from 'react'
import { Drawer } from 'antd'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { fetchCustomersDownloadHistory } from '../../../../actions/customer'
import DownloadItem from './DownloadItem'

export default ({ visible, onClose }) => {
  const userId = useAppSelector((state) => state.main.user?.user_id)
  const groupId = useAppSelector((state) => state.group.groupId)
  const dispatch = useAppDispatch()
  const [data, setData] = useState([])

  useEffect(() => {
    if (visible) {
      dispatch(
        fetchCustomersDownloadHistory({
          userId,
          groupId
        })
      ).then((res) => {
        setData(res.files || [])
      })
    }
  }, [visible])

  return (
    <Drawer
      open={visible}
      getContainer={false}
      onClose={onClose}
      size={440}
      title={
        <div className="download-history-header">
          <div className="title">下载记录</div>
          <div className="subtitle">历史下载记录最长保留7天</div>
        </div>
      }
    >
      {data.map(({ fileName, exportURL }, index) => (
        <DownloadItem
          key={fileName}
          fileName={fileName}
          exportURL={exportURL}
        />
      ))}
    </Drawer>
  )
}
